import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import Toast from 'react-native-toast-message';
import { centralAPI } from '../../services/central-api';
import { ClientError } from '../../services/central-api/base-service';
import CustomButton from '../../components/CustomButton';
import { RichTextEditor } from '../../components/RichTextEditor';
import Container from '../../components/Container';
import Card from '../../components/Card';
import Header from '../../components/Header';


export default function Notes() {
    const [loading, setLoading] = useState(true);

    const [annotation, setAnnotation] = useState({ dirty: false, value: '' });

    async function getUserNotes() {
        try {
            const note = await centralAPI.getOwnUserNotes();
            setAnnotation({ dirty: false, value: note.note });
        } catch (err) {
            console.error(err);
        }
        setLoading(false);
    }

    useEffect(() => {
        getUserNotes();
    }, []);


    async function save() {
        setLoading(true);
        try {
            await centralAPI.updateOwnUserNotes(annotation.value);

            setAnnotation({ value: annotation.value, dirty: false });

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
        setLoading(false);

    }

    return <Container>
        <Header
            title={translate('notes')}
            actions={<CustomButton
                onPress={save}
                disabled={!annotation.dirty}
                text={translate('save')}
            />}
        />
        <Card>
            {!loading &&
                <RichTextEditor text={annotation.value} onChangeText={(text) => setAnnotation({ dirty: true, value: text })} />
            }
        </Card>
    </Container>;
}
